<template>
	<div class="clear">
		<div id="portfolio-chart">
			<Chart
				v-if="forecasts"
				:series="forecasts"
				height="300px"
				portfolio_chart="true"
			/>
		</div>
	</div>
</template>

<script>
import Chart from "@/components/pages/sub-components/Chart";

export default {
	name: "PortfolioAgregated",
	components: {
		Chart
	},
	props: ["forecasts"]
};
</script>
